var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { formLabelClasses } from '@mui/material/FormLabel';
export var createMuiFormLabelOverrides = function (_a) {
    var _b;
    var spacing = _a.spacing, typography = _a.typography, tokens = _a.tokens;
    return {
        styleOverrides: {
            root: __assign(__assign({}, typography.subtitle2), (_b = { color: tokens.color_fg_bold, marginBottom: spacing(1) }, _b["&.".concat(formLabelClasses.error)] = {
                color: tokens.color_fg_state_danger,
            }, _b["&.".concat(formLabelClasses.focused, "&:not(.").concat(formLabelClasses.error, "), &.").concat(formLabelClasses.disabled)] = {
                color: tokens.color_fg_bold,
            }, _b)),
            asterisk: {
                color: tokens.color_fg_state_danger,
            },
        },
    };
};
